import {gsap} from "gsap";

export default class StopMainScroller {
	static instance = null;

	static create(options) {
		if (!StopMainScroller.instance) {
			StopMainScroller.instance = new StopMainScroller(options);
		}
		return StopMainScroller.instance;
	}

	static destroy() {
		if (StopMainScroller.instance) {
			StopMainScroller.instance.beforeDestroy();
			StopMainScroller.instance = null;
		}
	}

	get defaultOptions() {
		return {
			container: document.querySelector('.ui-menu')
		}
	}


	constructor(options) {
		this.options = Object.assign(this.defaultOptions, options);
		this.mm = gsap.matchMedia();
		this.selector = this.options.container.querySelector('.ui-menu');

		this.mm.add('(min-width: 768px)', () => {
			this.init();
		});

		this.mm.add('(max-width: 76px)', () => {
			StopMainScroller.destroy();
		});


	}

	start() {
		window.scroller.start();
	}

	stop() {
		window.scroller.stop();
	}

	init() {
		if (this.selector) {
			this.selector.addEventListener('mouseenter', () => {
				this.stop();
			})

			this.selector.addEventListener('mouseleave', () => {
				this.start();
			})
		}
	}

	beforeDestroy() {

		if (this.selector) {
			this.selector = null;
			this.mm = null;
		}

	}
}